export default __webpack_public_path__ + "static/help_06_05_3-f7831ab11bf0d082da2571ecdccd6d2e.png";